import { z } from 'zod'

/**
 * Where an item came from: hugo itself or one of the systems it collects from. A module of its
 * own because items.ts (itemSchema) and plan.ts (a heads-up names its item's source) both need
 * it, and items.ts imports plan.ts: this keeps the imports free of cycles. items.ts re-exports it.
 */
export const itemSources = [
  'hugo',
  'gmail',
  'chat',
  'calendar',
  'drive',
  'github',
  'jira',
  'confluence',
  'hubspot',
] as const
export const itemSourceSchema = z.enum(itemSources)
export type ItemSource = z.output<typeof itemSourceSchema>
